// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Xolx","colBig":"styles_colBig__1i37K","colSmall":"styles_colSmall__2ibIO","shopifyNameWrapper":"styles_shopifyNameWrapper__3WFPv"};